module.exports = __webpack_public_path__ + "static/HF_LFK3-aacbe7da5f7600ee1ffc523ad8dd3ff1.png";